var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "8" } },
                [
                  _c("form-write-group-label-input", {
                    staticClass:
                      "h5 font-weight-bold text-dark bg-light p-3 border rounded",
                    attrs: {
                      isMandatory: "",
                      id: "bic-input",
                      inputLabel: _vm.$t("common.global.bic"),
                    },
                    model: {
                      value: _vm.BIC,
                      callback: function ($$v) {
                        _vm.BIC = $$v
                      },
                      expression: "BIC",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "8" } },
                [
                  _c("form-read-group-label-input", {
                    staticClass:
                      "h5 font-weight-bold text-dark bg-light p-3 border rounded",
                    attrs: {
                      isMandatory: "",
                      id: "bic-display",
                      inputLabel: _vm.$t("common.global.bic"),
                      inputValue: _vm.BIC,
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }